"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getVersionIdFromVersion_1 = tslib_1.__importDefault(require("./getVersionIdFromVersion"));
function getContentVersionIdFromVersions(versions, contentId) {
    try {
        const versionInfo = (versions || []).find(version => version.contentId === contentId);
        if (!versionInfo) {
            return undefined;
        }
        return getVersionIdFromVersion_1.default(versionInfo);
    }
    catch (error) {
        throw new Error('Error in getVersionIdOfContent ' + error);
    }
}
exports.default = getContentVersionIdFromVersions;
//# sourceMappingURL=getVersionIdOfContent.js.map